import useTenantState from '@/states/tenant.state';
import useAuthState from '@/states/auth.state';
import { TenantDiscussionTab } from './TenantDiscussionTab';
import { Loader2 } from 'lucide-react';
import useCompanyState from '@/states/company.state';
import { useCompanyProfileSteps } from '@/hooks/useCompanyProfileSteps';
import VideoPlayer from '@/components/VideoPlayer';

const Discussion = () => {
  const { currentTenant } = useTenantState();
  const { isSuperAdmin, userProfile } = useAuthState();

  useCompanyProfileSteps();
  const { companyProfileSteps } = useCompanyState();
  const videoLink = companyProfileSteps.find(step => step.step_name.toLowerCase() === 'discussion')?.video_link;

  if (!currentTenant || !userProfile) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <Loader2 className="w-16 h-16 text-blue-500 mx-auto mb-4 animate-spin" />
          <p className="text-lg font-medium text-gray-900">Memuat...</p>
        </div>
      </div>
    );
  }

  return (
    <section className="w-full h-[calc(100vh-96px)]">
      <div className="p-2 md:p-5 h-full">
        <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 h-full flex flex-col">
          <div className="border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex-none hidden md:block">
            <div className="flex items-start justify-between gap-4">
              <div>
                <h1 className="text-xl font-semibold text-gray-900 dark:text-white">Diskusi</h1>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                  Ruang diskusi untuk berkomunikasi dengan administrator
                </p>
              </div>
              {videoLink && <VideoPlayer url={videoLink} title="Diskusi" />}
            </div>
          </div>
          <div className="p-3 md:p-6 flex-1 min-h-0">
            <TenantDiscussionTab
              tenantId={currentTenant.id}
              currentUser={{
                id: userProfile.id,
                name: userProfile.name,
                role: isSuperAdmin ? 'superadmin' : userProfile.tenants?.[0]?.roles?.[0] || 'admin',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Discussion;
